export enum SlotsEnum {
    B = 'B',
    L='L',
    D='D',
    BL='BL',
    BD='BD',
    LD='LD',
    BLD='BLD'
}